import {Button, DialogActions, Stack, TextField, DialogTitle, DialogContent} from "@mui/material";
import React, {useState} from "react";
import Dialog from "@mui/material/Dialog";
import {DeviceModalProps, IDevice} from "../../../common/interfaces/devices";
import {createToastNotification} from "../../../utilities/helpers";
import {insertDevice, updateDevice} from "../../../api/devices";


const DeviceModal: React.FC<DeviceModalProps> = ({
                                                     open,
                                                     onClose,
                                                     onSave,
                                                     deviceData,
                                                     setDeviceData
                                                 }) => {

    const[name, setName] = useState(deviceData?.name)
    const[description, setDescription] = useState(deviceData?.description)
    const[ipAddress, setIpAddress] = useState(deviceData?.ipAddress)

    const handleSave = async () => {
        const formData = {id: deviceData?.id, name, description,ipAddress};
        if(!name?.trim()) {
            createToastNotification('info', 'Popunite naziv uređaja');
            return;
        }

        if(!ipAddress.trim()) {
            createToastNotification('info', 'Popunite ip adresu');
            return;
        }

        try {
            if(formData.id) {
                await updateDevice(formData as IDevice);
            } else {
                await insertDevice(formData as IDevice);
            }
            createToastNotification('success', 'Uređaj je uspešno sačuvan');
            onClose();
        } catch (error: any) {
            createToastNotification('error', error.response?.data?.message);

        }
    }

    React.useEffect(() => {
        setName(deviceData?.name ?? '');
        setDescription(deviceData?.description ?? '');
        setIpAddress(deviceData?.ipAddress ?? '');
    }, [deviceData]);

    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
            <DialogTitle>{deviceData.id ? "Izmeni uređaj" : "Dodaj novi uređaj"}</DialogTitle>
            <DialogContent>
                <Stack spacing={2} mt={1}>
                    <TextField
                        label="Naziv"
                        name="name"
                        value={deviceData.name}
                        onChange={(e) => setDeviceData({ ...deviceData, name: e.target.value })}
                        fullWidth
                        required
                        InputLabelProps={{ required: true }}
                    />
                    <TextField
                        label="Opis"
                        name="description"
                        value={deviceData.description}
                        onChange={(e) => setDeviceData({ ...deviceData, description: e.target.value })}
                        fullWidth
                        multiline
                        rows={3}
                    />
                    {!deviceData.id ? null : (
                    <TextField
                        label="Status"
                        name="status"
                        value={deviceData.status}
                        fullWidth
                        InputProps={{ readOnly: true }}
                    />
                    )}
                    <TextField
                        label="IP Adresa"
                        name="ipAddress"
                        value={deviceData.ipAddress}
                        onChange={(e) => setDeviceData({ ...deviceData, ipAddress: e.target.value })}
                        fullWidth
                        required
                        InputLabelProps={{ required: true }}
                    />
                </Stack>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary">Odustani</Button>
                <Button onClick={handleSave} color="success" variant="contained">Sačuvaj</Button>
            </DialogActions>
        </Dialog>
    );
};

export default DeviceModal;
